import process from "process";
import Cookies from "js-cookie";
const API_BASE_URL =process.env.REACT_APP_API_URL; // Remplacez par l'URL de base de votre API
let docViewWindow = null;
const role = Cookies.get("Role")

export async function presignedURL(token, docId, modelId, instanceId, clientId) {
  console.log(docId, modelId, instanceId, clientId)
  // Validation des paramètres pour s'assurer qu'ils ne sont pas undefined
  if (!token || !docId || !modelId || !instanceId || !clientId) {
    console.error('Un ou plusieurs paramètres requis sont undefined', { token, docId, modelId, instanceId, clientId });
    throw new Error('Un ou plusieurs paramètres requis sont undefined');
  }
  
  const isSuperAdmin = role === "superadmin";
  const apiUrl = `${API_BASE_URL}${isSuperAdmin ? "/admin" : ""}/document/view`;

  const body = {
    InstanceId: instanceId,
    ModelId: modelId,
    Duration: 600,
    DocumentId: docId,
    ...(isSuperAdmin && { ClientId: clientId })
  };

  console.log("API URL:", apiUrl);
  console.log("Payload:", body);

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data);

    return data.message.PresignedURL;
  } catch (error) {
    throw new Error(error.message);
  }

}
